import { useState } from 'react';
import Skeleton from '../Skeleton';
import { countryFlag } from '../../constants/assets';
import { CountryFlagProps } from './types';

export default function CountryFlag({ countryCode, size = 32, className, style }: CountryFlagProps) {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <>
      {isLoading && (
        <Skeleton
          variant="circular"
          width={size}
          height={size}
          style={{ ...style, display: isLoading ? 'block' : 'none', borderRadius: '50%' }}
        />
      )}
      <img
        src={countryFlag(countryCode)}
        alt={`${countryCode} flag`}
        width={size}
        height={size}
        className={className}
        style={{
          ...style,
          display: isLoading ? 'none' : 'block',
          borderRadius: '50%',
        }}
        onLoad={() => setIsLoading(false)}
      />
    </>
  );
}
